import PlatformForm from "./PlatformForm";
export default PlatformForm;